// Minimal browser stub for node:path.
// Only the subset used by @nowline/export-core is needed;
// those calls are purely informational path string construction and are never
// exercised at runtime in the browser (fonts are loaded via atob(), not fs).
export const sep = '/';
export const dirname = (p: string) => p.replace(/\/[^/]*$/, '') || '.';
export const basename = (p: string, ext?: string) => {
    const base = p.split('/').pop() ?? '';
    return ext && base.endsWith(ext) ? base.slice(0, -ext.length) : base;
};
export const extname = (p: string) => {
    const base = p.split('/').pop() ?? '';
    const dot = base.lastIndexOf('.');
    return dot > 0 ? base.slice(dot) : '';
};
export const isAbsolute = (p: string) => p.startsWith('/');
export const join = (...parts: string[]) => parts.filter(Boolean).join(sep).replace(/\/+/g, sep);
export const resolve = (...parts: string[]) => parts.filter(Boolean).join(sep);
export const win32 = { sep: '\\', join, resolve, basename, extname, dirname, isAbsolute };
export default { sep, dirname, basename, extname, isAbsolute, join, resolve, win32 };
